import { useState, useEffect } from "react";
import { api } from "@/lib/api";

/** Polls the care-team messaging unread count for the sidebar nav badge. */
export function useUnreadMessages(intervalMs = 60000) {
    const [unread, setUnread] = useState(0);
    useEffect(() => {
        let active = true;
        const fetchCount = () => api.get("/messages/unread-count")
            .then((r) => { if (active) setUnread(r.data.count || 0); })
            .catch(() => {});
        fetchCount();
        const id = setInterval(fetchCount, intervalMs);
        return () => { active = false; clearInterval(id); };
    }, [intervalMs]);
    return unread;
}
